import { MoneyDisplay } from '@/components/shared/money-display';
import { StatCard } from '@/components/shared/stat-card';
import type { CurrencyAmount } from '@/lib/money-totals';
import { visibleCurrencyAmounts } from '@/lib/money-totals';

export const MoneyTotalsStack = ({
  items,
  size = 'md',
}: {
  items: CurrencyAmount[];
  size?: 'sm' | 'md' | 'lg';
}) => {
  if (items.length === 0) return null;
  if (items.length === 1) {
    return <MoneyDisplay amount={items[0]!.amountMinor} currency={items[0]!.currency} size={size} />;
  }
  return (
    <div className="flex flex-col items-end gap-0.5">
      {items.map((item) => (
        <MoneyDisplay
          key={item.currency}
          amount={item.amountMinor}
          currency={item.currency}
          size={size}
        />
      ))}
    </div>
  );
};

export const MetricMoneyCards = ({
  label,
  items,
  loading,
  baseCurrency,
}: {
  label: string;
  items: CurrencyAmount[];
  loading?: boolean;
  baseCurrency?: string;
}) => {
  const visibleItems = baseCurrency ? visibleCurrencyAmounts(items, baseCurrency) : items;

  if (visibleItems.length <= 1) {
    return (
      <StatCard
        label={label}
        money={
          visibleItems[0]
            ? { amount: visibleItems[0].amountMinor, currency: visibleItems[0].currency }
            : undefined
        }
        loading={loading}
      />
    );
  }

  return (
    <>
      {visibleItems.map((item) => (
        <StatCard
          key={item.currency}
          label={`${label} (${item.currency})`}
          money={{ amount: item.amountMinor, currency: item.currency }}
          loading={loading}
        />
      ))}
    </>
  );
};
